import {isRunPinned} from '../../../state/views/runSet/utils';
import {type WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {useRunSelectorFeatureEnabled} from '../RunSelectorFeaturesContext';
import {
  usePinnedAndBaseline,
  useRunSetGroupSelectionGrouping,
} from '../RunSelectorRunSetContext';
import {isRunBaseline} from '../util';

export function useRowPinningState(row: WBTableRowWithRunSetInfo) {
  const isEnabled = useRunSelectorFeatureEnabled();
  const isBaselineEnabled = isEnabled('baselining');
  const isPinnedRunsEnabled = isEnabled('pinning');

  const grouping = useRunSetGroupSelectionGrouping();
  const {pinnedRunIds, baselineRunId} = usePinnedAndBaseline();

  if (grouping.length) {
    return {
      isRunPinned: false,
      isRunBaseline: false,
    };
  }

  return {
    isRunPinned: isPinnedRunsEnabled && isRunPinned(pinnedRunIds, row),
    isRunBaseline:
      isBaselineEnabled &&
      isPinnedRunsEnabled &&
      isRunBaseline(baselineRunId, row),
  };
}
